import { Fragment, PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { MessageStatus } from '../messageStatus';

type PropsT = {
  /** The parent conversation csid */
  csid: number;
  className?: any;
};

export default class StatusIsForward extends PureComponent<PropsT> {
  constructor(props: PropsT) {
    super(props);
  }

  generateStatusText(csid: number) {
    return (
      <Fragment>
        <span>
          This is a transcript of conversation{' '}
          <Link to={`/conversation/${csid}`}>#{csid}</Link>
        </span>
      </Fragment>
    );
  }

  render() {
    const { csid, ...otherProps } = this.props;

    return (
      <MessageStatus
        {...(otherProps as any)}
        text={this.generateStatusText(csid) as any}
      />
    );
  }
}
